import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import { ErroDaRota } from '@/components/layout/ErroDaRota';
import type { CodigoDaTela } from '@/features/permissoes/telas';
import type { Servicos } from '@/lib/servicos';
import { routeTree } from '@/routeTree.gen';

/** O que os `loader`s e as guardas das rotas recebem. */
export interface ContextoDoRoteador extends Servicos {
  queryClient: QueryClient;
}

export function criarRoteador(
  contexto: ContextoDoRoteador,
  historico?: Parameters<typeof createRouter>[0]['history'],
) {
  return createRouter({
    routeTree,
    context: contexto,
    ...(historico !== undefined && { history: historico }),
    defaultPreload: 'intent',
    // Os dados ficam no TanStack Query; o roteador não guarda cópia (ADR-0005).
    defaultPreloadStaleTime: 0,
    // A restauração de rolagem do roteador grava no sessionStorage; o painel não grava nada fora
    // de lib/preferencias.ts (constituição III.1; spec 002, CA-07).
    scrollRestoration: false,
    // Guarda de tela (sem acesso) e falha de carregamento aparecem no lugar da tela (spec 003).
    defaultErrorComponent: ErroDaRota,
  });
}

export type Roteador = ReturnType<typeof criarRoteador>;

declare module '@tanstack/react-router' {
  interface Register {
    router: Roteador;
  }

  /** Marcação das rotas do painel (spec 003): item do menu, título da aba e guarda. */
  interface StaticDataRouteOption {
    /** Código da tela no catálogo (`features/permissoes/telas.ts`); use `rotaDeTela`. */
    tela?: CodigoDaTela;
    /** Título da aba para rotas fora do catálogo (ex. Minha conta). */
    titulo?: string;
    /** Área da plataforma (super-admin); use `rotaDaPlataforma`. */
    plataforma?: boolean;
  }
}
